"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TawkTo_1 = __importDefault(require("./TawkTo"));
exports.default = TawkTo_1.default;
//# sourceMappingURL=index.js.map